import {
  OMSMetricsRequestSchema,
  OMSMetricsResponseSchema,
} from "@redotech/redo-model/fulfillments/metrics";

export const getAvgShippingRevenuePerOrder = {
  name: "getAvgShippingRevenuePerOrder" as const,
  input: OMSMetricsRequestSchema,
  output: OMSMetricsResponseSchema,
};
